import { getEnvVariable } from '@/utils';

export const IS_PROD = getEnvVariable('REACT_APP_IS_PROD', 'false') === 'true';